import React from "react";
import SvgIcon from "./SvgIcon";
import back from "@/assets/img/icons/Back.svg";
interface HeaderBarProps {
  title: string;
  onBack?: () => void;
  rightContent?: React.ReactNode;
  backgroundColor?: string;
}

const HeaderBar: React.FC<HeaderBarProps> = ({
  title,
  onBack,
  rightContent,
  backgroundColor,
}) => (
  <div className={`flex items-center justify-between h-[56px] w-full mx-auto ${backgroundColor}`}>
    <button
      className="w-[56px] h-[56px] flex items-center justify-center rounded-full hover:bg-white/10 transition flex-shrink-0"
      onClick={onBack}
      aria-label="Назад"
      type="button"
    >
      {onBack && (
        <SvgIcon
          src={back}
          className="w-6 h-6"
          color="#ffffff"
          size={24}
        />
      )}
    </button>
    <div className="text-center text-white font-bold font-ubuntu text-[17px]">
      {title}
    </div>
    <div className="w-10 flex items-center justify-center">
      {rightContent || null}
    </div>
  </div>
);

export default HeaderBar;
